import React, { useState } from 'react';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';

const FeelLuckyInline = ({ time, name }) => {
  const navigate = useNavigate();
  const [songs, setSongs] = useState([]);

  const handleLoadSongs = async () => {
    try {
      const url = `/feelluckyx?time=${time}`;
      const response = await fetch(url);
      if (response.status === 401) {
        window.location.href = '/';
        return;
      }
      const data = await response.json();
      setSongs(data);
      navigate('/builder/feellucky', { state: { songs: data } });
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <Button variant="primary" onClick={handleLoadSongs}>
      {name || 'Feel Lucky'}
    </Button>
  );
};

export default FeelLuckyInline;
